module.exports = __webpack_public_path__ + "img/loginman.7019c576.svg";